import QRCode from 'react-qr-code';
import styles from './styles.module.scss';
import { useContext } from 'react';
import { ReactSVG } from 'react-svg';
import { LoaderContext } from '../../App';
import { Button } from '../../components';
import { httpService } from '../../services';
import { FC, useState, useEffect } from 'react';

const getLink = async () => {
  const url = '/api/v1/diia/auth';
  const res = await httpService.get({ url, headers: {}, params: {} });
  const { errorMessage, link } = httpService.parseResponse(res);

  if (errorMessage) {
    alert(errorMessage);
  }

  return link;
};

const startCountdown = (durationInSeconds: number, setTimer: Function) => {
  let timeLeft = durationInSeconds;

  const updateDisplay = () => {
    const minutes = Math.floor(timeLeft / 60);
    const seconds = timeLeft % 60;
    const timerStr = `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
    setTimer(timerStr);

    if (timeLeft <= 0) {
      clearInterval(interval);
    } else {
      timeLeft--;
    }
  };

  updateDisplay();
  const interval = setInterval(updateDisplay, 1000);
};

const Auth: FC<{}> = () => {
  const { setLoader } = useContext(LoaderContext);
  const [timer, setTimer] = useState<string>('00:00');
  const [link, setLink] = useState<string>('');
  const isBtnDisabled = timer !== '00:00';
  const threeMinutesInSeconds = 3 * 60;

  useEffect(() => {
    fetchData();
  }, []);

  async function fetchData() {
    setLoader({ isLoading: true, title: 'Генеруємо QR код' });
    const resLink = (await getLink()) || '';
    // const link = resLink ? `https://diia.page.link?link=${resLink}` : resLink;
    setLink(resLink);
    /* Timer */
    resLink && startCountdown(threeMinutesInSeconds, setTimer);
    setLoader({ isLoading: false, title: '' });
  }

  const onGenerate = () => {
    fetchData();
  };

  return (
    <section className={styles['Auth']}>
      <div className={styles['content-wrapper']}>
        <h1 className={styles['title']}>Авторизація за допомогою Дія.Підпису.</h1>
        <div className={styles['tool-wrapper']}>
          <Button isDisable={isBtnDisabled} className={styles['btn']} onClick={onGenerate}>
            Згенерувати код повторно
          </Button>
          <span className={styles['timer']}>{timer}</span>
        </div>
        <h2 className={styles['subtitle']}>
          Відскануйте сканером застосунку QR-код та дотримуйтеся подальших інструкцій.
        </h2>

        <div className={styles['qr-wrapper']}>
          {link ? (
            <QRCode bgColor="transparent" className={styles['qr-img']} value={link} />
          ) : (
            <></>
          )}
        </div>
      </div>
      <ReactSVG className={styles['img']} src="/images/icons/scan-qr.svg" title="Scan qr code" />
    </section>
  );
};

export { Auth };
